/* ⚠️ GENERATED from app/services/avatarFaceApply.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/avatarFaceApply.ts — a reading becomes a look.
//
// 🟢 ONE RULE, BOTH CLIENTS. What the model says about hair, skin, eyes and
//    build has to become catalogue choices, and the arithmetic (a darkness and
//    a redness into one of twelve hair swatches, a rung on the skin ladder into
//    a hex) belongs in one place rather than in two builders.

import { SKIN_TONES, HAIR_COLORS, HAIR_STYLES, EYE_COLORS, normalizeSpec } from './avatarKit';

/** The hair swatch a darkness (0…1) and a redness (0…1) point at. */
export function hairColorFor(dark, red) {
  const d = Math.max(0, Math.min(1, Number(dark) || 0));
  const r = Math.max(0, Math.min(1, Number(red) || 0));
  if (r > 0.55) return HAIR_COLORS[d > 0.5 ? 10 : 11]; // auburn / ginger
  /* 0 = white … 1 = black over the eight natural browns and blonds */
  const ladder = [9, 7, 6, 5, 4, 3, 2, 1, 0];
  const i = Math.round((1 - d) * (ladder.length - 1));
  return HAIR_COLORS[ladder[Math.max(0, Math.min(ladder.length - 1, i))]];
}

/** The skin swatch a rung on the ladder points at. */
export function skinToneFor(step) {
  const i = Math.max(0, Math.min(SKIN_TONES.length - 1, Math.round(Number(step) || 0)));
  return SKIN_TONES[i];
}

/**
 * Fold a reading into a spec. Only what the model actually answered is used;
 * a style it invented, or a colour it could not see, leaves that field alone.
 */
export function applyFaceReading(spec, reading) {
  const s = normalizeSpec(spec);
  if (!reading) return s;
  const next = {
    ...s,
    face3d: reading.face,
    body3d: reading.body
  };
  if (Number.isFinite(reading.build)) next.build = reading.build;
  next.skin = skinToneFor(reading.skinTone);
  if (HAIR_STYLES.includes(reading.hairStyle)) {
    next.hair = {
      style: reading.hairStyle,
      color: hairColorFor(reading.hairDark, reading.hairRed)
    };
  } else {
    next.hair = {
      ...s.hair,
      color: hairColorFor(reading.hairDark, reading.hairRed)
    };
  }
  if (EYE_COLORS.includes(reading.eyeColor)) next.eyes = reading.eyeColor;
  return normalizeSpec(next);
}
